import React, {useCallback, useEffect, useState} from "react";
import {getFAQList, updateFAQCount, getFAQData} from "../../Wizard/_redux/wizardCrud";
import {Modal} from "react-bootstrap";

export function NotificationBody({ data, store }) {
    const { /*name,*/ contents } = data;
    const { idx } = store;
    const [contentsMap, setContentsMap] = useState([]);
    const [faqList, setFaqList] = useState([]);
    const [faqData, setFaqData] = useState({title: "", contents: "", crt_dtm: ""});
    const [title, setTitle] = useState("notice");
    const [modal, setModal] = useState(false);
    const arr = useCallback(
        () => {
            const contentList = contents.split("<p>&nbsp;</p>");
            const arr = []
            for(const item of contentList ){
                if(item !== "") arr.push(item)
            }
            setContentsMap(arr)
        },
        [contents],
    );

    useEffect(() => {
            arr();
            getFAQList(idx)
            .then(res => {
                setFaqList(res.data.data);
            });
    }, [arr, idx]);

    const openModal = (data) => {
        setModal(true);
        updateFAQCount(data.idx)
        .then(res => {
            console.log(res.data.data);
        })
        getFAQData(idx, data.idx)
        .then(res => {
            console.log(res.data.data[0]);
            setFaqData(res.data.data[0]);
        })
    }

    const clearModal = () => {
        setModal(false);
        setFaqData({title: "", contents: "", crt_dtm: ""});
    }

    return (
        <div className="flex-grow-1 pb-5">
            {/* begin::Info */}
            {/* <div className="d-flex align-items-center pr-2 border-bottom pb-2">
                <span
                    className="text-dark font-weight-bolder font-size-h4 flex-grow-1 ">
                    {name}
                </span>
            </div> */}
            <ul className="nav nav-tabs nav-tabs-line">
                <li className="nav-item">
                    <button className={"nav-link"+(title === "notice" ? " active" : "")} data-toggle="tab"  onClick={() => {setTitle("notice");}} style={{padding: "10px", margin: "0px"}}>공지사항</button>
                </li>
                <li className="nav-item">
                    <button className={"nav-link"+(title === "faq" ? " active" : "")} data-toggle="tab" onClick={() => {setTitle("faq");}} style={{padding: "10px", margin: "0px"}}>F.A.Q</button>
                </li>
            </ul>
            {/* end::Info */}

            {/* begin::Desc */}
            {title === "notice" ?
                <p dangerouslySetInnerHTML={{__html: contentsMap}} className="text-dark-50 font-weight-normal font-size-lg mt-6 justify-content-center "/> :
                ''
            }
            {title === "faq" ?
                <div className='table-responsive mt-6'>
                    <table className='table align-middle gs-0 gy-4'>
                        <thead>
                            <tr style={{textAlign:"left"}}>
                                <th>No.</th>
                                <th>제목</th>
                                <th>날짜</th>
                            </tr>
                        </thead>
                        <tbody>
                        {faqList.map((data, index) => (
                            <tr key={'faq-' + index} onClick={() => {
                                openModal(data);
                            }}>
                                <td>
                                    <div className='d-flex align-items-center'>
                                        <span style={{marginLeft: '16px'}} className='text-muted fw-bold text-muted d-block fs-7'>{data.idx}</span>
                                    </div>
                                </td>

                                <td>
                                    <div className='d-flex align-items-center'>
                                        <div className='d-flex justify-content-start flex-column'>
                                            <p className='text-dark fw-bolder text-hover-primary mb-1 fs-6'>
                                                {data.title}
                                            </p>
                                        </div>
                                    </div>
                                </td>

                                <td>
                                    <p className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6 min-w-75px'>
                                        {data.crt_dtm.substring(0,10)}
                                    </p>
                                </td>
                            </tr>
                    ))} </tbody></table></div>
                    :
                    ''    
                } 

                <Modal show={modal} onHide={clearModal}>
                    <div className='modali-content'>
                        <div className='modal-header'>
                            <h6 className='modal-title' style={{textAlign:"left"}}>{faqData.title}</h6>
                            <p className='modal-title' style={{textAlign:"right", fontSize:"12px", minWidth: "126px"}}>{faqData.crt_dtm.substring(0,10)}</p>
                        </div>
                        <div className='modal-body' style={{textAlign: 'left', whiteSpace: 'pre-wrap'}}>
                            <p>{faqData.contents}</p>
                        </div>
                        <div className='modal-footer'>
                            <button type='button' className='btn btn-light' onClick={() => {clearModal();}}>
                            닫기
                            </button>
                        </div>
                    </div>
                </Modal>
        </div>
    )

}